import React from 'react';
import { Heading } from '@chakra-ui/react';

const PropertyComponentTitle = ({children, ...rest}) => (
  <Heading as="h2" mb={2} mt={0} {...rest}>{children}</Heading>
);

export default PropertyComponentTitle;
